import postPath from './postPath';
import type { DocumentType } from '../../graphql/generated/gql';
import { gql } from '../../graphql/generated/gql';
import { isFeatureEnabled } from '../features';

const HISTORY_PATH_FRAGMENT = gql(`
  fragment historyPath_post on Post {
    id
    ...postPath_post
  }
`);

type PostFragment = DocumentType<typeof HISTORY_PATH_FRAGMENT>;

export default function historyPath(
  ...args:
    | [
        {
          post: PostFragment;
          versionFrom: number;
          versionTo: number;
        },
      ]
    | [PostFragment, number, number]
): string {
  if (args.length === 1) {
    const { post, versionFrom, versionTo } = args[0];
    return historyPath(post, versionFrom, versionTo);
  }

  const [post, versionFrom, versionTo] = args;

  if (isFeatureEnabled('history_v2')) {
    return postPath(post, { histories: `${versionFrom}-${versionTo}` });
  }

  return `${postPath(post)}/histories/${versionFrom}/${versionTo}`;
}
